// src/redux/searchSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { getDeltaDayFormattedDate } from 'components/Briefing/helpers';

const searchSlice = createSlice({
  name: 'search',
  initialState: {
    startDate: getDeltaDayFormattedDate(1),
    endDate: getDeltaDayFormattedDate(-1),
    searchTerm: "",
  },
  reducers: {
    setStartDate: (state, action) => {
      state.startDate = action.payload;
    },
    setEndDate: (state, action) => {
      state.endDate = action.payload;
    },
    setSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
    },
  },
});

export const { setStartDate, setEndDate, setSearchTerm } = searchSlice.actions;
export default searchSlice.reducer;
